import React, { useContext, useEffect } from 'react';
import {
  getMessaging,
  getToken,
  deleteToken,
  onMessage,
} from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { messaging, sendDeniedRequest, sendPostRequest } from '../../firebase';
import { GlobalSearchContext } from '../../context/GlobalSearchContext';
import { getCurrentAuth } from '../../hooks/http-server';
import useCommonDetails from '../../hooks/useCommonDetails';
import { hasRole, ROLE_IDS } from '../../utils/constant';

const PushNotificationManager: React.FC = () => {
  const {
    fetchCount,
    fetchBroadcastNotifications,
    fatchCurrentTaggingRequest,
  }: any = useContext(GlobalSearchContext);
  const key = process.env.REACT_APP_VAPIDKEY;
  const auth = getCurrentAuth();
  const currentUserInfo = useCommonDetails();
  useEffect(() => {
    const handleNotificationPermission = async () => {
      try {
        const permission = Notification.permission;

        if (permission === 'denied') {
          // console.log('Notification permission denied by the user.');
          await deleteFirebaseToken();
        } else if (permission === 'default') {
          // console.log('Notification permission not determined yet.');
          // Optionally request permission
          const newPermission = await Notification.requestPermission();
          if (newPermission === 'denied') {
            // console.log('User denied permission after request.');
            await deleteFirebaseToken();
          }
        } else {
          // console.log('Notification permission granted.');
          await registerFirebaseToken();
        }
      } catch (error) {
        console.error('Error handling notification permission:', error);
      }
    };
    const deleteFirebaseToken = async () => {
      await sendDeniedRequest();
      const currentToken = await getToken(messaging);
      // console.log(currentToken);
      try {
        if (currentToken) {
          await deleteToken(messaging);
          // console.log('Firebase token deleted.');
        } else {
          console.log('No token to delete.');
        }
      } catch (error) {
        console.error('Error deleting Firebase token:', error);
      }
    };

    const registerFirebaseToken = async () => {
      try {
        const currentToken = await getToken(messaging, {
          vapidKey: key, // Replace with your VAPID key
        });

        if (currentToken) {
          // console.log('Firebase token registered:', currentToken);
          // Optionally send the token to your backend
          await sendPostRequest(currentToken);
          localStorage.setItem('NotificationToken', currentToken);
        } else {
          console.log('No registration token available. Request permission.');
        }
      } catch (error) {
        console.error('Error registering Firebase token:', error);
      }
    };
    // onMessage(messaging, (payload: any) => {
    //   // console.log('Foreground notification received:', payload);

    //   const notificationOptions = {
    //     body: payload.notification.body,
    //     icon: payload.data.icon, // Access the icon from payload
    //   };
    //   // fetchCount();
    //   handelToggelFlag();
    //   new Notification(payload.notification.title, notificationOptions);
    // });
    onMessage(messaging, (payload: any) => {
      if (auth.Token) {
        fetchCount();
        fetchBroadcastNotifications();
        // Tagging request + unassigned-periods count only matter for team 3
        // taggers; calling it for everyone made each broadcast notification
        // stampede the heavy /v2/unassigned-periods endpoint.
        if (
          hasRole(currentUserInfo?.roleId, [ROLE_IDS.TAGGER]) &&
          currentUserInfo?.teamId === 3
        ) {
          fatchCurrentTaggingRequest();
        }
      }
    });
    handleNotificationPermission();
  }, []);

  return <div></div>;
};

export default PushNotificationManager;
